if (!customElements.get("product-form")) {
    class ProductForm extends HTMLElement {
        constructor() {
            super();
            if (this.hasChildNodes()) this.init();
        }

        init() {
            this.form = this.querySelector(
                ".js-product-form"
            );
            if (this.form) {
                this.form.querySelector(
                    '[name="id"]'
                ).disabled = false;
                this.cartDrawer =
                    document.querySelector("cart-drawer");
                this.submitBtn =
                    this.querySelector('[name="add"]');

                if (theme.settings.afterAtc !== "no-js") {
                    this.addEventListener(
                        "submit",
                        this.handleSubmit.bind(this)
                    );
                }
            }
        }

        /**
         * Handles submission of the product form.
         * @param {object} evt - Event object.
         */
        async handleSubmit(evt) {
            if (evt.target.id === "product-signup_form")
                return;

            evt.preventDefault();

            if (
                this.submitBtn.getAttribute(
                    "aria-disabled"
                ) === "true"
            )
                return;

            if (
                theme.settings.vibrateOnATC &&
                window.navigator.vibrate
            ) {
                window.navigator.vibrate(100);
            }

            this.errorMsg = null;
            this.setErrorMsgState();

            // Disable "Add to Cart" button until submission is complete.
            this.submitBtn.setAttribute(
                "aria-disabled",
                "true"
            );
            this.submitBtn.classList.add("is-loading");

            // prepare form data
            const formData = new FormData(this.form);
            let sections = "cart-icon-bubble";
            if (this.cartDrawer) {
                sections += `,${this.cartDrawer
                    .closest(".shopify-section")
                    .id.replace("shopify-section-", "")}`;
            }
            formData.append(
                "sections_url",
                window.location.pathname
            );
            formData.append("sections", sections);

            // Wrap the submission in the activeRequest promise
            window.activeRequest =
                window.activeRequest.then(async () => {
                    try {
                        // 获取当前购物车
                        const oldCartResponse = await fetch(
                            `${theme.routes.cart}.js`
                        );
                        if (!oldCartResponse.ok)
                            throw new Error(
                                oldCartResponse.status
                            );
                        const oldCartData =
                            await oldCartResponse.json();

                        // 获取新商品信息
                        const newVariantId = Number(
                            formData.get("id")
                        );
                        const newQuantity = Number(
                            formData.get("quantity") || 1
                        );
                        const newSku = formData.get("sku");

                        // 先添加新商品到购物车
                        const addItemResponse = await fetch(
                            `${window.Shopify.routes.root}cart/add.js`,
                            {
                                method: "POST",
                                headers: {
                                    "Content-Type":
                                        "application/json",
                                },
                                body: JSON.stringify({
                                    id: newVariantId,
                                    quantity: newQuantity,
                                    sections: sections,
                                    sections_url:
                                        window.location
                                            .pathname,
                                }),
                            }
                        );

                        const addItemData =
                            await addItemResponse.json();

                        // 检查添加商品是否成功
                        if (addItemData.status) {
                            let error =
                                typeof addItemData.description ===
                                "string"
                                    ? addItemData.description
                                    : addItemData.message;
                            if (
                                addItemData.errors &&
                                typeof addItemData.errors ===
                                    "object"
                            ) {
                                error = Object.entries(
                                    addItemData.errors
                                ).map((item) =>
                                    item[1].join(", ")
                                );
                            }
                            this.setErrorMsgState(error);
                            throw new Error("添加商品失败");
                        }

                        if (!addItemResponse.ok)
                            throw new Error(
                                `添加商品失败: ${addItemResponse.status}`
                            );

                        // 获取更新后的购物车
                        const updatedCartResponse =
                            await fetch(
                                `${theme.routes.cart}.js`
                            );
                        if (!updatedCartResponse.ok)
                            throw new Error(
                                updatedCartResponse.status
                            );
                        const updatedCartData =
                            await updatedCartResponse.json();

                        // 检查购物车中所有商品的库存状态
                        const availableCartItems =
                            await this.filterAvailableItems(
                                updatedCartData.items
                            );

                        // 准备排序所有有库存的购物车商品
                        const sortedCartItems =
                            availableCartItems
                                .map((item) => ({
                                    id: item.variant_id,
                                    quantity: item.quantity,
                                    sku: item.sku || "",
                                }))
                                .sort((a, b) => {
                                    const skuA = (
                                        a.sku || ""
                                    ).toUpperCase();
                                    const skuB = (
                                        b.sku || ""
                                    ).toUpperCase();
                                    return skuA.localeCompare(
                                        skuB
                                    );
                                })
                                .reverse();

                        let data = addItemData; // 默认使用添加商品的响应数据

                        try {
                            // 安全地清空并重建购物车，使用事务操作
                            // 1. 清空购物车
                            const clearCartResponse =
                                await fetch(
                                    "/cart/clear.js",
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-Type":
                                                "application/json",
                                        },
                                        body: JSON.stringify(
                                            {}
                                        ),
                                    }
                                );

                            if (!clearCartResponse.ok) {
                                throw new Error(
                                    "清空购物车失败，将保留添加了新商品的购物车"
                                );
                            }

                            // 2. 批量添加所有排序后的商品
                            const sortedData = {
                                items: sortedCartItems.map(
                                    (item) => ({
                                        id: item.id,
                                        quantity:
                                            item.quantity,
                                    })
                                ),
                                sections: sections,
                                sections_url:
                                    window.location
                                        .pathname,
                            };

                            const sortResponse =
                                await fetch(
                                    `${window.Shopify.routes.root}cart/add.js`,
                                    {
                                        method: "POST",
                                        headers: {
                                            "Content-Type":
                                                "application/json",
                                        },
                                        body: JSON.stringify(
                                            sortedData
                                        ),
                                    }
                                );

                            if (!sortResponse.ok) {
                                // 如果排序失败，需要恢复原有购物车
                                console.error(
                                    "排序失败，正在恢复原有购物车..."
                                );

                                // 恢复原有购物车商品（只恢复有库存的）
                                const availableOldItems =
                                    await this.filterAvailableItems(
                                        oldCartData.items
                                    );
                                if (
                                    availableOldItems.length >
                                    0
                                ) {
                                    const restoreData = {
                                        items: availableOldItems.map(
                                            (item) => ({
                                                id: item.variant_id,
                                                quantity:
                                                    item.quantity,
                                            })
                                        ),
                                        sections: sections,
                                        sections_url:
                                            window.location
                                                .pathname,
                                    };

                                    try {
                                        const restoreResponse =
                                            await fetch(
                                                `${window.Shopify.routes.root}cart/add.js`,
                                                {
                                                    method: "POST",
                                                    headers:
                                                        {
                                                            "Content-Type":
                                                                "application/json",
                                                        },
                                                    body: JSON.stringify(
                                                        restoreData
                                                    ),
                                                }
                                            );

                                        if (
                                            restoreResponse.ok
                                        ) {
                                            console.log(
                                                "原有购物车已恢复"
                                            );
                                        }
                                    } catch (restoreError) {
                                        console.error(
                                            "恢复购物车失败",
                                            restoreError
                                        );
                                    }
                                }

                                throw new Error(
                                    "排序失败，已恢复原有购物车"
                                );
                            }

                            // 更新响应数据为排序后的数据
                            data =
                                await sortResponse.json();
                        } catch (sortError) {
                            console.error(
                                "购物车排序失败",
                                sortError
                            );

                            // 如果排序失败，商品已经成功添加到购物车，只是顺序可能不正确
                            // 这种情况下，仍然继续处理，不抛出错误
                            console.log(
                                "继续处理，使用未排序的购物车"
                            );
                        }

                        if (
                            theme.settings.afterAtc ===
                            "page"
                        ) {
                            // Allow the tick animation to complete
                            setTimeout(() => {
                                window.location.href =
                                    theme.routes.cart;
                            }, 300);
                        } else {
                            // Update cart icon count.
                            ProductForm.updateCartIcon(
                                data
                            );

                            // If item was added from Quick Add drawer, show "Added to cart" message.
                            const quickAddDrawer =
                                this.closest(
                                    "quick-add-drawer"
                                );
                            if (quickAddDrawer)
                                quickAddDrawer.addedToCart();

                            setTimeout(() => {
                                // Update cart drawer contents.
                                if (this.cartDrawer) {
                                    this.cartDrawer.renderContents(
                                        data,
                                        !quickAddDrawer &&
                                            theme.settings
                                                .afterAtc ===
                                                "drawer"
                                    );
                                } else if (
                                    window.location
                                        .pathname ===
                                    theme.routes.cart
                                ) {
                                    const cartItems =
                                        document.querySelector(
                                            "cart-items"
                                        );
                                    if (cartItems) {
                                        if (
                                            cartItems
                                                .dataset
                                                .empty ===
                                            "true"
                                        ) {
                                            window.location.reload();
                                        } else {
                                            cartItems.refresh();
                                        }
                                    }
                                }
                            }, 700);
                        }

                        // 获取最终的购物车状态
                        const newCartResponse = await fetch(
                            `${theme.routes.cart}.js`
                        );
                        if (!newCartResponse.ok)
                            throw new Error(
                                newCartResponse.status
                            );
                        const newCartData =
                            await newCartResponse.json();

                        // 查找旧购物车中是否有该商品
                        const itemInOldCart =
                            oldCartData.items.find(
                                (item) =>
                                    item.variant_id ===
                                    newVariantId
                            );

                        // 触发相应的事件
                        if (itemInOldCart) {
                            this.dispatchEvent(
                                new CustomEvent(
                                    "on:line-item:change",
                                    {
                                        bubbles: true,
                                        detail: {
                                            cart: newCartData,
                                            variantId:
                                                newVariantId,
                                            oldQuantity:
                                                itemInOldCart.quantity,
                                            newQuantity:
                                                itemInOldCart.quantity +
                                                newQuantity,
                                        },
                                    }
                                )
                            );
                        } else {
                            this.dispatchEvent(
                                new CustomEvent(
                                    "on:cart:add",
                                    {
                                        bubbles: true,
                                        detail: {
                                            cart: newCartData,
                                            variantId:
                                                newVariantId,
                                        },
                                    }
                                )
                            );
                        }
                    } catch (error) {
                        console.log(error); // eslint-disable-line
                        this.dispatchEvent(
                            new CustomEvent(
                                "on:cart:error",
                                {
                                    bubbles: true,
                                    detail: {
                                        error: this.errorMsg
                                            ? this.errorMsg
                                                  .textContent
                                            : "添加购物车失败",
                                    },
                                }
                            )
                        );
                    } finally {
                        // Re-enable 'Add to Cart' button.
                        this.submitBtn.classList.add(
                            "is-success"
                        );
                        this.submitBtn.removeAttribute(
                            "aria-disabled"
                        );
                        setTimeout(() => {
                            this.submitBtn.classList.remove(
                                "is-loading"
                            );
                            this.submitBtn.classList.remove(
                                "is-success"
                            );
                        }, 1400);
                    }
                });
        }

        /**
         * Updates the cart icon count in the header.
         * @param {object} response - Response JSON.
         */
        static updateCartIcon(response) {
            const cartIconBubble = document.getElementById(
                "cart-icon-bubble"
            );
            if (cartIconBubble) {
                cartIconBubble.innerHTML =
                    response.sections["cart-icon-bubble"];
            }
        }

        /**
         * Filters cart items to only include available products
         * @param {Array} cartItems - Array of cart items to filter
         * @returns {Promise<Array>} - Array of available cart items
         */
        async filterAvailableItems(cartItems) {
            if (!cartItems || cartItems.length === 0)
                return [];

            // Create concurrent requests to check product availability
            const availabilityPromises = cartItems.map(
                async (item) => {
                    try {
                        const response = await fetch(
                            `/products/${item.handle}.js`
                        );
                        if (!response.ok) {
                            console.warn(
                                `Failed to fetch product data for ${item.handle}`
                            );
                            return {
                                item,
                                available: false,
                            };
                        }

                        const productData =
                            await response.json();
                        const variant =
                            productData.variants.find(
                                (v) =>
                                    v.id === item.variant_id
                            );

                        return {
                            item,
                            available: variant
                                ? variant.available
                                : false,
                        };
                    } catch (error) {
                        console.error(
                            `Error checking availability for ${item.handle}:`,
                            error
                        );
                        return { item, available: false };
                    }
                }
            );

            // Wait for all availability checks to complete
            const availabilityResults = await Promise.all(
                availabilityPromises
            );

            // Filter out unavailable items and log removed items
            const availableItems = [];
            const removedItems = [];

            availabilityResults.forEach(
                ({ item, available }) => {
                    if (available) {
                        availableItems.push(item);
                    } else {
                        removedItems.push(item);
                        console.log(
                            `Removed out-of-stock item: ${item.title} (SKU: ${item.sku})`
                        );
                    }
                }
            );

            if (removedItems.length > 0) {
                console.log(
                    `Filtered out ${removedItems.length} out-of-stock items from cart`
                );
            }

            return availableItems;
        }

        /**
         * Shows/hides an error message.
         * @param {string} [error=false] - Error to show a message for.
         */
        setErrorMsgState(error = false) {
            this.errorMsg =
                this.errorMsg ||
                this.querySelector(".js-form-error");
            if (!this.errorMsg) return;

            this.errorMsg.hidden = !error;
            if (error) {
                this.errorMsg.innerHTML = "";
                const errorArray = Array.isArray(error)
                    ? error
                    : [error];
                errorArray.forEach((err, index) => {
                    if (index > 0)
                        this.errorMsg.insertAdjacentHTML(
                            "beforeend",
                            "<br>"
                        );
                    this.errorMsg.insertAdjacentText(
                        "beforeend",
                        err
                    );
                });
            }
        }
    }

    customElements.define("product-form", ProductForm);
}
